module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-7-zoom.06f60e2e.png";